import React, { useContext, useMemo } from 'react';

import useLocalStorage from '../hooks/useLocalStorage';


type UserContextProps = {
  setUser: (...args: any[]) => any;
  user: any
}

const UserContext = React.createContext<UserContextProps | undefined>(undefined);

type Props = {
	children: React.ReactNode | React.ReactNode[];
};


function UserProvider({ children }: Props) {
	// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
	const [user, setUser] = useLocalStorage(null);

	const defaultValue = useMemo(
		() => ({
			user,
			setUser,
		}),
		[user, setUser]
	);
	return <UserContext.Provider value={defaultValue}>{children}</UserContext.Provider>;
}

function useUser() {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error(`useUser must be used within a UserProvider`);
	}
	return context;
}

export { UserProvider, useUser };
